module.exports = __webpack_public_path__ + "img/UUID.fac9e988.svg";